import React from 'react';
const comparisons = [{
  bad: 'Pancia gonfia e pesantezza dopo ogni pasto.',
  good: 'Leggerezza reale e addome piatto da subito.'
}, {
  bad: 'Ore perse in cucina senza un piano.',
  good: 'Sai sempre cosa preparare in meno di 15 minuti.'
}, {
  bad: 'Spesa caotica, costosa e piena di sprechi.',
  good: 'Lista della spesa pronta, economica e ottimizzata.'
}, {
  bad: 'Fame nervosa e dipendenza dagli zuccheri.',
  good: 'Sazietà totale con il potere delle proteine "Senza".'
}];
export function ComparisonTable() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-31">
      <div className="max-w-xl mx-auto" data-id="element-32">
        <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4 text-center" data-id="element-33">
          <div className="font-bold text-brand-text-muted text-xs sm:text-sm uppercase tracking-wider" data-id="element-34">
            SENZA IL METODO
          </div>
          <div className="font-bold text-brand-olive text-xs sm:text-sm uppercase tracking-wider" data-id="element-35">
            CON RESET MEDITERRANEO™
          </div>
        </div>

        <div className="space-y-3" data-id="element-36">
          {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 gap-3 sm:gap-4 bg-white border border-brand-sage/30 rounded-xl p-3 sm:p-4 items-center" data-id="element-37">
              <div className="text-brand-text-muted text-xs sm:text-sm pr-2 border-r border-brand-sage/30" data-id="element-38">
                {item.bad}
              </div>
              <div className="text-brand-olive font-bold text-xs sm:text-sm pl-2" data-id="element-39">
                {item.good}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}